import { useMainCta } from '@/contexts/mainCta';
import { useHaptics } from '@/hooks/useHaptics';
import { cn } from '@/lib/cn';

/**
 * In-document call-to-action bar. Sits ABOVE the TabBar (between page content
 * and the bottom navigation), inverting Telegram's native MainButton position
 * which appears below the WebView. Routes register their CTA via
 * `useMainButton({ text, enabled, loading, onClick })`.
 */
export function MainCta() {
  const { cta } = useMainCta();
  const haptics = useHaptics();

  if (!cta) return null;

  const disabled = cta.enabled === false || cta.loading === true;

  return (
    <div className="border-t border-border bg-bg/95 px-4 pb-2 pt-2 backdrop-blur">
      <button
        type="button"
        disabled={disabled}
        onClick={() => {
          if (disabled) return;
          haptics.impact('light');
          cta.onClick();
        }}
        className={cn(
          'flex h-12 w-full items-center justify-center gap-2 rounded-full',
          'bg-brand text-base font-bold uppercase tracking-wide text-brand-fg',
          'transition-opacity active:opacity-80 disabled:opacity-50',
        )}
      >
        {cta.loading ? (
          <span
            aria-hidden
            className="h-5 w-5 animate-spin rounded-full border-2 border-brand-fg/30 border-t-brand-fg"
          />
        ) : (
          <span>{cta.text}</span>
        )}
      </button>
    </div>
  );
}
